module.exports = __webpack_public_path__ + "img/cw.50b20c20.svg";